import React from 'react';
import styles from '../../styles/CambioGrupoStyles/CambioGrupo.module.css';

function Header() {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h1 className={styles.headerTitle}>Cambio de Estudiante de Grupo</h1>
          <p className={styles.headerSubtitle}>Cambiar grupo y horario de una materia</p>
        </div>
        
        <div className={styles.headerRight}>
          <div className={styles.notificationIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
          </div>
          
          <div className={styles.userInfo}>
            <div className={styles.userAvatar}>
              <span>A</span>
            </div>
            <div className={styles.userDetails}>
              <span className={styles.userName}>Administrador</span>
              <span className={styles.userRole}>Admin General</span>
            </div>
            <div className={styles.userActions}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M6 9l6 6 6-6"/>
              </svg>
            </div>
          </div>
          
          <div className={styles.institutionSelector}>
            <span className={styles.institutionLabel}>Institución:</span>
            <select className={styles.institutionSelect}>
              <option value="universidad-lux">Universidad Lux</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
